/**
 * FeaturedVideo Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the FeaturedVideo template.
 *
 * @namespace FeaturedVideo
 */

import {register} from './../vendor/theme-scripts/theme-sections';
import debounce from '../util/debounce';
import openPhotoSwipe from '../util/open-photoswipe';

const sections = {};

const selectors = {
  shopifySection: '.shopify-section',
  headerContent: '.header__content',
  heroContent: '.hero__content',
  heroContentWrapper: '.hero__content__wrapper',
  videoPlay: '.js-video__play',
  dataHtml: 'data-html',
};

class FeaturedVideo {
  /**
   * FeaturedVideo section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */

  constructor(section) {
    this.container = section.container;
    this.parentContainer = this.container.closest(selectors.shopifySection);
    this.parentContainerIdx = Array.from(this.parentContainer.parentElement.children).indexOf(this.parentContainer);
    this.heroContent = this.container.querySelector(selectors.heroContent);
    this.heroContentWrapper = this.container.querySelector(selectors.heroContentWrapper);
    this.videoPlay = this.container.querySelector(selectors.videoPlay);
    const self = this;

    this.setMinHeight();

    window.addEventListener('resize', debounce(self.setMinHeight(), 100));

    this.videoPlay.addEventListener('click', function (e) {
      if (this.hasAttribute(selectors.dataHtml) && this.getAttribute(selectors.dataHtml).trim() !== '') {
        e.preventDefault();

        const items = [
          {
            html: this.getAttribute(selectors.dataHtml),
          },
        ];

        openPhotoSwipe(items);
      }
    });
  }

  setMinHeight() {
    const isFirstSection = this.parentContainerIdx == 0;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const headerContent = document.querySelector(selectors.headerContent);
    let headerContentHeight = 0;
    if (headerContent) {
      headerContentHeight = parseFloat(getComputedStyle(headerContent, null).height.replace('px', ''));
    }

    let headerHeight = windowWidth >= 750 ? headerContentHeight : 0;
    if (!isFirstSection) headerHeight = 0;
    const contentHeight = this.heroContent.offsetHeight;
    const minHeight = headerHeight + contentHeight;
    this.container.style.minHeight = `${minHeight}px`;
    this.heroContentWrapper.style.paddingTop = `${headerHeight}px`;
  }

  onReorder() {
    this.setMinHeight();
  }
}

const FeaturedVideoSection = {
  onLoad() {
    sections[this.id] = new FeaturedVideo(this);
  },
  onUnload(e) {
    sections[this.id].onUnload(e);
  },
  onBlockSelect(e) {
    sections[this.id].onBlockSelect(e);
  },
};

register('featured-video', FeaturedVideoSection);
